import React, { Component } from 'react'
import { Field } from 'redux-form'
import { Row, Col } from 'react-bootstrap'
import { Tooltip } from '@material-ui/core'
import { renderTextField } from '../../Forms/fieldRenderers'
import { required, getNumericValidator } from '../../Forms/fieldValidators'
import PaisDropdown from '../../Forms/SharedComponents/containers/PaisDropdown'

const maxLength = max => value =>
  value && value.length > max ? `Debe tener un máximo de ${max} caracteres de largo` : undefined

const numeric5 = getNumericValidator(1, 5)
const numeric15 = getNumericValidator(1, 15)

const maxLength8 = maxLength(8)
const url = 'https://www.marinetraffic.com'
const imageIcon = 'https://assets-global.website-files.com/64fc9df6b4daf05c9edad27a/651eec2f5e1d6043d45b4859_Kpler%20Marine%20Signet.svg'

class CamposBuque extends Component {
  render () {
    const { newBuque = false } = this.props
    return (
      <div style={{ margin: '22px auto', width: '98%' }}>
        <Row>
          <Col md={3}>
            <Field
              name='nombreCorto'
              type='text'
              label='Nombre Corto *'
              component={renderTextField}
              autoFocus={false}
              validate={[required, maxLength8]}
              upperCase
              placeholder=''
              maxLength={8}
            />
          </Col>
          <Col md={5}>
            <Field
              name='nombre'
              type='text'
              label='Nombre Completo *'
              component={renderTextField}
              autoFocus={false}
              upperCase
              validate={[required]}
              placeholder=''
            />
          </Col>
          <Col md={4}>
            <PaisDropdown required />
          </Col>

          <Col md={3}>
            <Field
              name='eslora'
              type='number'
              label='Eslora (Mts)'
              component={renderTextField}
              autoFocus={false}

              placeholder=''
            />
          </Col>
          <Col md={3}>
            <Field
              name='manga'
              type='number'
              label='Manga (Mts)'
              component={renderTextField}
              autoFocus={false}

              placeholder=''
            />
          </Col>
          <Col md={3}>
            <Field
              name='puntal'
              type='number'
              label='Puntal (Mts)'
              component={renderTextField}
              autoFocus={false}
              placeholder=''
            />
          </Col>
          <Col md={3}>
            <Field
              name='calado'
              type='number'
              label='Calado (Mts)'
              component={renderTextField}
              autoFocus={false}
              placeholder=''
            />
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <Field
              name='pesoBruto'
              type='number'
              label='Peso Bruto (Tns)'
              component={renderTextField}
              autoFocus={false}
              placeholder=''
            />
          </Col>
          <Col md={3}>
            <Field
              name='pesoDeDesplazamiento'
              type='number'
              label='Peso de Desplazamiento (Tns)'
              component={renderTextField}
              autoFocus={false}
              validate={[numeric5]}
              placeholder=''
            />
          </Col>
          <Col md={3}>
            <Field
              name='velocidadMaxima'
              type='number'
              label='Velocidad Máxima (Nmi/h)'
              component={renderTextField}
              autoFocus={false}
              placeholder=''
            />
          </Col>
          <Col md={3}>
            <Field
              name='velocidadMedia'
              type='number'
              label='Velocidad Media (Nmi/h)'
              component={renderTextField}
              autoFocus={false}
              placeholder=''
            />
          </Col>
        </Row>
        <Row>
          {newBuque
            ? <>
              <Col md={4}>
                <Field
                  name='atis'
                  type='text'
                  label='ATIS (Aut. Transmitter Ident. System)'
                  component={renderTextField}
                  autoFocus={false}
                  placeholder=''
                />
              </Col>
              <Col md={2}>
                <Field
                  name='bodegas'
                  type='text'
                  label='Bodegas'
                  component={renderTextField}
                  autoFocus={false}
                  validate={[numeric15]}
                  placeholder=''
                  maxLength={1}
                />
              </Col>
            </>
            : <Col md={6}>
              <Field
                name='atis'
                type='text'
                label='ATIS (Aut. Transmitter Ident. System)'
                component={renderTextField}
                autoFocus={false}
                placeholder=''
              />
            </Col>
          }
          <Col md={3}>
            <Field
              name='mmsi'
              type='text'
              label='# MMSI'
              component={renderTextField}
              autoFocus={false}
              placeholder=''
            />
          </Col>
          <Col md={3}>
            <Field
              name='imo'
              type='text'
              label='# IMO *'
              component={renderTextField}
              autoFocus={false}
              placeholder=''
            />
          </Col>
          <Col md={12} className='campos-buque-footer'>
            <Tooltip title={'MarineTraffic'}>
              <a href={url} target='blank' rel='' style={{ color: 'inherit', display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                <img src={imageIcon} alt='marine-traffic-icon' style={{ width: '22px', margin: '0 8px' }} />
                <p style={{ fontWeight: 'bold' }}>Marine Traffic</p>
              </a>
            </Tooltip>
            <p>(*) Campo requerido </p>
          </Col>
        </Row>
      </div>
    )
  }
}

export default CamposBuque
